<template>
  <div>
    <Component
      :is="`blueprint-${entry.blueprint?.replaceAll('_', '-')}`"
      v-if="entry"
      :page="entry"
    />
    
  </div>
</template>

<script setup lang="ts">
import type { PageQuery } from '#gql'

const emit = defineEmits<{
  'entry-loaded': [entry: PageQuery['entry']]
}>()
const entry = await useInjectableEntry()
watch(entry, e => emit('entry-loaded', e), { immediate: true })

// META TAGS
useSeotamic(entry)
await useHead({
  bodyAttrs: {
    class: useIsInLivePreview() ? 'live-preview-active' : '',
  },
})
</script>
